<template>
    <div v-on:keyup.esc="$root.$emit('CLOSERESTOREDIALOG')"
        class="dialog draggable-item light bg-light overflow w-100-sm w-100-md w-75-lg w-50-xl" v-cloak>

        <DialogTitle :title="$t('Restore of database backup')" :defaultTitle="$t('Restore of database backup')"
        :subTitle="$t('SQLServer restore')" @closeDialog="$root.$emit('CLOSERESTOREDIALOG')" />

        <div class="dialog-content p-4" style="overflow:auto;">
            <!-- SELEZIONE DEI BACKUP E DEL SINGOLO RESTORE RELATO AL JOB-->
            <div class="row" v-show="steps[0]">

                <div v-if="wait" data-role="activity" data-type="metro" data-style="dark"></div>
                <div v-if="logs !== null" id="dblogslist" class="border bd-light p-4 w-100" style="overflow-y: scroll;overflow-x: hidden;">   
                    
                    <!-- Titolo -->
                    <h6 class="mb-3 text-bold">{{ $t('Backup executions') }}</h6>

                    <ul v-if="logs.length > 0" data-role="listview" data-view="content" data-select-node="true">

                        <li v-for="(forlog) in logs" :key="forlog.id" class="mb-2" data-icon="<span class='mif-stack'>"
                            :data-caption="convertDate(forlog.dt_start_utc)"
                            :data-content="`<span class='text-muted'>${convertDate(forlog.dt_end_utc)} - ${prettyBytes(forlog.backup_size)} - ${forlog.copied_files} ${$t('files')}</span>`"
                            @click="getJobConfiguration(forlog)">
                        </li> 
                                    
                    </ul>      
                    <p v-else>{{ $t('No Logs available') }}</p> 
                </div>

            </div>
            <!-- SELEZIONE DEI BACKUP PER RESTORE-->
            <div class="row" v-show="steps[1]">
                <div v-if="waitvm" data-role="activity" data-type="metro" data-style="dark"></div>
                <div v-if="databasesinbackup != null" id="dblist" class="border bd-light p-4 w-100" style="overflow-y: scroll;overflow-x: hidden;">
                  
                    <!-- Titolo -->
                    <h5 class="mb-3 text-bold">{{ $t('Backup available') }}</h5>

                    <ul v-if="databasesinbackup.length > 0" data-role="listview" data-view="content" data-select-node="true">

                        <li v-for="(db, index) in databasesinbackup" :key="db.Name" data-icon="<span class='mif-server'>"
                            :data-caption="db.Name"
                            :data-content="`<span class='text-muted'>${$t('Database Name')}</span>`"
                            @click="setDbSelected(db, index)">
                        </li> 
                                
                    </ul>      
                    <p v-else>{{ $t('No Backup available') }}</p>     

                </div>
            </div>

            <div class="row mt-4" v-if="steps[2] && databasestorestore.length > 0">
                <div class="row mt-4 ml-2">
                    <div class="cell-12">
                        <p>{{ $t("Backup file:") }}</p>
                    </div>
                    <div class="cell-8 text-bold">
                        <span>{{ job.destinations[0].path + '\\' }} {{ dbnametorestore + '.bak' }} </span>
                    </div>
                    <!--div class="cell-4">
                        <button class="button secondary ml-2" v-on:click="toggleFileSystemSidebar()">{{ $t('Select path') }}</button>
                    </div-->
                    <div class="cell-8 mt-4">
                        <input type="radio" data-role="radio" id="NewDatabase" value="NewDatabase" v-model="picked"
                            :data-caption="$t('Make the restore creating a new database with the following name')" />
                    </div>
                    <div class="cell-8">
                        <input type="text" data-role="input" v-model="userDbName" :class="{ 'disabled': picked != 'NewDatabase' }" v-fsitem>
                    </div>
                    <div class="cell-8">
                        <input type="radio" data-role="radio" id="OverwriteDatabase" value="OverwriteDatabase"
                            v-model="picked" :data-caption="$t('Make the restore overwriting an existing database')" />
                    </div>
                    <div class="cell-8">
                        <select data-role="select" data-filter="false" :disabled="picked != 'OverwriteDatabase'" v-model="selectedDB">
                            <option v-for="db in job.sources[0].dbSource.Databases" :key="db.Name" :value="db">{{ db.Name }}</option>
                        </select>
                    </div>
                </div>

            </div>

            <div v-if="steps[3] && restore" class="container-fluid">

                <div class="row mt-4 ml-2">
                    <div class="cell-8">
                        <label>{{ $t("Database") }}: <b>{{ restore.restorename }}</b></label>
                    </div>
                    <div class="cell-8">
                        <label v-if="restore.dt_start_utc != '' && restore.dt_start_utc != null">{{ $t("Start") }}: <b>{{
                            restore.dt_start_utc.toLocalDate() }}</b></label>
                    </div>
                    <div class="cell-8">
                        <LastResult :lastresult="restore.lastresult" />
                    </div>
                    <div class="cell-6">
                        <div v-show="restore.progress != null && restore.progress != 0">
                            <div class="clear pb-3">
                                <small class="place-left" data-role="hint"
                                    data-hint-position="top" :data-hint-text="restore.current_operation">{{ restore.current_operation }}</small>
                                <!--small v-else-if="restore.current_operation <= 100" class="place-left" data-role="hint"
                                    data-hint-position="top" :data-hint-text="restore.current_operation">{{restore.current_operation.substr(0, 50) + "..."}}</small>
                                <small v-else class="place-left" data-role="hint" data-hint-position="top"
                                    :data-hint-text="restore.current_operation">{{restore.current_operation.substr(0,50) + "..." + restore.current_operation.substr(-50, 50)}}</small-->
                            </div>
                            <div data-role="progress" data-type="line" :data-value="restore.progress" data-small="true"
                                data-cls-bar="bg-secondary" data-role-progress="true" class="progress small">
                                <div class="bar ribbed-secondary" :style="{ width: restore.progress + '%' }">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="cell-2">
                        <small v-if="restore.isRunning" class="place-right text-bold enlarge-1">{{ restore.progress }} %</small>
                    </div>
                </div>

            </div>

        </div>
        <div class="dialog-actions">
             <div class="ml-auto">                
                <button class="button secondary" v-show="steps[1] || steps[2]" @click="back"><span class="mif-arrow-left"></span> {{ $t('Back') }}</button>
                <button class="button secondary" v-show="steps[0] || steps[1]" :disabled="isNextButtonDisabled" v-disable-tooltip:nextButtonDisabled_message @click="next">{{ $t('Next') }} <span class="mif-arrow-right"> </span> </button>
                <button class="button secondary" v-show="steps[2]" :disabled="isRestoreButtonDisabled" v-disable-tooltip:restoreButtonDisabled_message @click="startRestore"><span class="mif-checkmark pr-2"></span>{{ $t('Restore') }}</button>
                <button class="button float-right ml-2" @click="$root.$emit('CLOSERESTOREDIALOG')">{{ $t('Close') }}</button>
            </div>
        </div>

    </div>
</template>
<script>
import DialogTitle from "../../utils/DialogTitle";
import { prettyBytes } from '../../../utils/utilitiesmodule';
import api from "../../../router/api";
import $ from 'jquery'
import { draggableMixin } from "../../../mixins/draggable-mixin";
import LastResult from "../../utils/LastResult.vue";

export default {
    name: "DatabaseDestinationRestore",
    mixins: [draggableMixin],
    props: {
        idPC: String,
        idJob: {
            type: String,
            required: true
        },
    },
    components: {
        "DialogTitle": DialogTitle,
        LastResult
    },
    filters: {
        prettyBytes: function(bytes, precision) {
            return prettyBytes(bytes, precision);
        }
    },
    computed: {

        restoreButtonState() {

            if (this.steps[2]&&this.job.destinations[0].path=='') {
                return {
                    rdisabled: true,
                    rmessage: this.$t('Backup path is not valid.')
                };
            }

            if (this.picked=='NewDatabase'&&this.userDbName=='') {
                return {
                    rdisabled: true,
                    rmessage: this.$t('Enter a database name to continue the restore.')
                };
            }

            if (this.picked=='OverwriteDatabase'&&this.selectedDB==null) {
                return {
                    rdisabled: true,
                    rmessage: this.$t('Select a database name to continue the restore.')
                };
            }

            return {
                rdisabled: false,
                rmessage: ''
            };

        },

        isRestoreButtonDisabled() {
            return this.restoreButtonState.rdisabled;
        },

        restoreButtonDisabled_message() {
            return this.restoreButtonState.rmessage;
        },

        nextButtonState() {
            // 1) step[0] + nessun job
            if (this.steps[0]&&!this.jobselected) {
                return {
                    disabled: true,
                    message: this.$t('Select a job before continuing.')
                };
            }

            // 2) step[1] + nessun database nello store
            const hasDb=this.databasestorestore&&this.databasestorestore.length>0;
            if (this.steps[1]&&!hasDb) {
                return {
                    disabled: true,
                    message: this.$t('Select a database backup before continuing.')
                };
            }

            // 3) step[2] → Next disabilitato (segue "Save")
            if (!!this.steps[2]) {
                return { disabled: true, message: '' };
            }

            // 4) default: serve almeno un item selezionato (se questa regola è ancora valida)
            // se non ti serve più, rimuovi questa parte
            return {
                disabled: false,
                message: ''
            };
        },

        isNextButtonDisabled() {
            return this.nextButtonState.disabled;
        },

        nextButtonDisabled_message() {
            return this.nextButtonState.message;
        }
    },

    data() {
        return {
            steps: [1, 0, 0, 0],

            wait: true,
            waitvm: true,
            jobselected: '',
            checkedNames: [],
            id_service_account: -2,

            job: {},
            logs: null,

            go: false,
            justOneGuid: '',

            restores: null, // socket [GT - 06/06/2023]
            restore: null,

            DatabaseRestoreModel: {
                Id: '',
                JobId: '',
                Version: '',
                IdServiceAccount: '',
                DatabaseToRestorePath: '',
                CreateNewDatabase: false,
                DatabaseToCreateName: '',
                OverWriteExistingDatabase: false,
                DatabaseToOverwriteName: '',
                type: 6,
                type_name: 'Database',
            },

            databasesinbackup: [],
            databasestorestore: [],

            dbnametorestore: '',
            picked: 'NewDatabase',
            customCopyFilePath: [],
            userDbName: '',
            selectedDB: null,

            source: {},
            destination: {},


            folder: null,

            connection: null,

            portchech: null,
            port: null,
        }
    },

    created: function() {
        this.getLogsList();
    },

    methods: {

        // primo metodo ad essere eseguito
        // mostra tutte le esecuzioni con relativa configurazione
        async getLogsList() {
            let self=this;

            await this.$api.getBackupLogs(self.idJob).then(response => {
                self.logs=response;
                if (self.logs&&self.logs.length==1) {
                    self.getJobConfiguration(self.logs[0]);
                }
                self.wait=false;
            });

        },

        async getJobConfiguration(log) {

            let self=this;
            self.jobselected=''; // svuoto la variabile che attiva pulsante next

            self.selectedlog=log;

            await this.$api.getBackupLogConfiguration(log.id).then(response => {

                self.job={}

                if (!self.job) {
                    self.job=response;
                }
                else {
                    self.job=Object.assign(self.job, response)
                }

                if (self.job.options) {
                    self.options=self.job.options
                }

                //valorizza l'array con le caselle di posta incluse nel singolo backup
                self.populateDBArray();

                self.jobselected=log.id; // attiva il pulsante next           

            });


        },

        //valorizza l'array con i database inclusi nel singolo backup
        populateDBArray() {
            let self=this;
            self.waitvm=true;

            //job.sources.0.exchangeSource.Mailboxes

            // svuoto array
            self.databasesinbackup.splice(0);

            const selected=(self.job?.sources??[])
                .flatMap(sc => sc?.dbSource?.Databases??[])
                .filter(db => db?.Selected);

            self.databasesinbackup.push(...selected);


            if (self.databasesinbackup.length==1) {
                this.setDbSelected(self.databasesinbackup[0]);
            }

            setTimeout(function() {

                self.waitvm=false;

            }, 1000);

        },


        async setDbSelected(db) {

            let self=this;
            if (self.databasestorestore.find(f => f.Name==db.Name)==null) {
                self.databasestorestore.push(db);
            }

            self.dbnametorestore=db.Name;

        },



        getBackup() {

            let self=this;
            api
                .get('/jobs/'+self.idJob+"?fview=true")
                .then(response => {

                    console.log("api get jobs idbackup");

                    if (!self.job) self.job=response.data;
                    else self.job=Object.assign(self.job, response.data);

                    if (self.job.options) self.options=self.job.options;

                });
        },

        convertDate(date) {
            date=this.$moment(date.substr(0, 8)+"T"+date.substr(8), "YYYYMMDD HH:mm:ss");
            return this.$moment.utc(date).format("ddd DD/MM/YYYY HH:mm:ss");
        },

        prettyBytes: function(bytes, precision) {
            return prettyBytes(bytes, precision);
        },

        toggle(id) {
            if ($('#'+id).css('display')=='none')
                $('#'+id).slideDown(250);
            else
                $('#'+id).slideUp(250);
        },

        /*********************************UTILS**************************************/
        setIdServiceAccount() {
            this.$root.$emit('setIdServiceAccount', this.id_service_account);
            if ((typeof this.id_service_account)=='string')
                this.connection.invoke("GetVirtualMachinesESXi", this.id_service_account);
        },

        next() {
            var next=true;


            this.steps.forEach((step, index) => {
                if (step==1) {
                    if (next) {
                        this.$set(this.steps, index+1, true)
                        this.$set(this.steps, index, false)
                        next=false;

                    }
                }
            });

        },
        back() {
            var next=true;
            this.steps.forEach((step, index) => {
                if (step==1) {
                    if (next) {
                        this.$set(this.steps, index-1, true)
                        this.$set(this.steps, index, false)
                        next=false;

                    }
                }
            });

        },



        async startRestore() {
            this.$root.$emit("closeFileSystemSidebar");
            let self=this;

            this.$root.$on("startRestore_feedback", ok => {
                if (ok.status==self.$ResultValue.OK) {
                    self.startRestore_confirmed();
                }

                this.$root.$off("startRestore_feedback");
            });

            this.$root.$emit("startRestore", this.job.name);
        },

        async startRestore_confirmed() {
            var next=true;
            let self=this;

            // faccio vedere la sezione del progress
            this.steps.forEach((step, index) => {
                if (step==1) {
                    if (next) {
                        this.$set(this.steps, index+1, true)
                        this.$set(this.steps, index, false)
                        next=false;

                    }
                }
            });

            self.justOneGuid=self.uuidv4();

            self.DatabaseRestoreModel.Id=self.justOneGuid;
            self.DatabaseRestoreModel.JobId=self.job.id;
            self.DatabaseRestoreModel.IdServiceAccount=self.job.sources[0].id_service_account;
            self.DatabaseRestoreModel.Version='',
                self.DatabaseRestoreModel.DatabaseToRestorePath=self.job.destinations[0].path+'\\'+self.dbnametorestore+'.bak';//self.customCopyFilePath[0].path;
            if (self.picked=='NewDatabase') {
                self.DatabaseRestoreModel.CreateNewDatabase=true;
                self.DatabaseRestoreModel.DatabaseToCreateName=self.userDbName
                self.DatabaseRestoreModel.backupName=self.userDbName;
            } else //OverwriteDatabase
            {
                self.DatabaseRestoreModel.OverWriteExistingDatabase=true;
                self.DatabaseRestoreModel.DatabaseToOverwriteName=self.selectedDB.name;
                self.DatabaseRestoreModel.backupName=self.selectedDB.name;
            }

            self.DatabaseRestoreModel.type=self.job.sources[0].type;
            self.DatabaseRestoreModel.type_name=self.job.sources[0].type_name;


            console.log("[DatabaseRestore.startRestore]");
            // runexchangerestore
            this.$root.socket("RUNDATABASERESTORE", self.DatabaseRestoreModel);

            // invoca agent per dare start ad invio delle informazioni sul restore
            self.idPC=this.$session.getRoomPC()?.id;


            // subscrive per ricevere il progress del restore ---------------------
            this.$root.$on("addRestoreToPage", restores => {
                console.log('Restore in popup');
                if (restores) {
                    //console.log(restores);
                    self.restore=restores[self.justOneGuid];
                }


            });
            // --------------------------------------------------------------------

        },

        uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                .replace(/[xy]/g, function(c) {
                    const r=Math.random()*16|0,
                        v=c=='x'? r:(r&0x3|0x8);
                    return v.toString(16);
                });
        },

        beforeDestroy: function() {
            this.$root.$off("socketEventConnected");
            this.$root.$off("socketEventDisconnected");
            if (this.connection!=null) this.connection.stop();
        },
    },
}
</script>